<template>
    <div>
        <div style="text-align: left">
            <div class="searchbarcls">
                模块名称:<el-input  size="small" v-model="searchForm.roleName"  style="width: 200px;"></el-input>
                &nbsp;<el-button type="primary" icon="el-icon-search" size="small" @click="loadTableData()">查询</el-button>
            </div>
            <div style="padding: 2px;">
                <el-button type="primary" plain size="mini" @click="showAddOneLevelDialog()">一级菜单</el-button>
                <el-button type="success" plain size="mini" @click="showAddTwoLevelDialog()">二级菜单</el-button>
                <el-button type="warning" plain size="mini" @click="showAddModuleDialog()">模块菜单</el-button>
            </div>
        </div>
        <el-table
                ref="myElTable"
                background="true"
                :data="tableData"
                :height="clientHeight-otherHeight"
                row-key="id"
                :tree-props="{children: 'children'}"
                default-expand-all
                @row-click="tableTrClick"
                border style="width: 100%;">
            <el-table-column type="selection" width="43"/>
            <el-table-column type="index" label="序号" fixed="left" width="50"/>
            <el-table-column prop="permissionname" label="模块名称" width="260">
                <template slot-scope="scope">
                    <span :style="{ fontWeight: getStyle(scope.row) }">{{ scope.row.permissionname }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="permissionname" label="模块等级" width="80">
                <template slot-scope="scope">
                    <span :style="{ fontWeight: getStyle(scope.row) }">{{ leavelFormatter(scope.row) }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="permissionurl" :formatter="urlFormatter" label="模块路径" width="460">
            </el-table-column>
            <el-table-column prop="permissionindex" label="排序" width="60">
                <template slot-scope="scope">
                    <span :style="{ fontWeight: getStyle(scope.row) }">{{ scope.row.permissionindex }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="permissionremark" label="备注" />
            <el-table-column fixed="right" label="操作" width="220">
                <template slot-scope="scope">
                    <el-button type="success" size="mini" plain v-if="scope.row.permissionurl&&scope.row.permissionpid!='superparent'" @click="updatePermission(scope.row)">修 改</el-button>
                    <el-button type="danger" size="mini" plain v-if="scope.row.permissionurl&&scope.row.permissionpid!='superparent'" @click="deletePermission(scope.row)">删 除</el-button>
                    <el-button type="info" size="mini" plain v-if="scope.row.ischildren=='y'" @click="showAddMethodDialog(scope.row)">方法</el-button>
                </template>
            </el-table-column>
        </el-table>
        <!--添加div-->
        <el-dialog
                title="新增一级菜单信息"
                size="33%"
                :visible.sync="drawer"
                :wrapperClosable="false"
                direction="rtl">
            <AddOneLevelWindow ref="addOneLevelWindow" :closeWindow="closeWindow"></AddOneLevelWindow>
        </el-dialog>
        <!--二级菜单-->
        <el-dialog
                title="新增二级菜单信息"
                size="33%"
                :visible.sync="twoDrawer"
                :wrapperClosable="false"
                direction="rtl">
            <AddTwoLevelWindow ref="addTwoLevelWindow" :selectedPerData="selectedPerData" :closeWindow="closeWindow"></AddTwoLevelWindow>
        </el-dialog>
        <!--模块菜单-->
        <el-dialog
                title="新增模块菜单信息"
                size="33%"
                :visible.sync="moduleDrawer"
                :wrapperClosable="false"
                direction="rtl">
            <AddModuleWindow ref="addModuleWindow" :selectedPerData="selectedPerData" :closeWindow="closeWindow"></AddModuleWindow>
        </el-dialog>
        <!--模块菜单-->
        <el-dialog
                title="更新模块菜单信息"
                width="880px"
                :visible.sync="umoduleDrawer"
                :wrapperClosable="false"
                direction="rtl">
            <UpdateModuleWindow ref="updateModuleWindow" :selectedPerData="selectedPerData" :closeWindow="closeWindow"></UpdateModuleWindow>
        </el-dialog>
        <!--模块菜单-->
        <el-dialog
                title="更新菜单信息"
                width="880px"
                :visible.sync="uoneLevelDrawer"
                :wrapperClosable="false"
                direction="rtl">
            <UpdateOneLevelWindow ref="updateOneLevelWindow" :selectedPerData="selectedPerData" :closeWindow="closeWindow"></UpdateOneLevelWindow>
        </el-dialog>
        <!--模块菜单-->
        <el-dialog
                title="功能方法"
                width="1080px"
                :visible.sync="pmdDrawer"
                :wrapperClosable="false"
                direction="rtl">
            <PermissionMdWindow ref="permissionMdWindow" :selectedPerData="selectedPerData" :closeWindow="closeWindow"></PermissionMdWindow>
        </el-dialog>
    </div>
</template>
<script>
    import {appjs} from "@/utiljs/apputil";
    import AddOneLevelWindow from "./AddOneLevelWindow.vue";
    import AddTwoLevelWindow from "./AddTwoLevelWindow.vue";
    import AddModuleWindow from "./AddModuleWindow.vue";
    import UpdateModuleWindow from "./UpdateModuleWindow.vue";
    import PermissionMdWindow from "./PermissionMdWindow.vue";
    import UpdateOneLevelWindow from "./UpdateOneLevelWindow.vue";
    export default {
        components: {
            AddOneLevelWindow,
            AddTwoLevelWindow,
            AddModuleWindow,
            PermissionMdWindow,
            UpdateModuleWindow,
            UpdateOneLevelWindow
        },
        props: {
            clientHeight: {
                type: Number
            }
        },
        data() {
            return {
                otherHeight:175,
                drawer: false,
                twoDrawer: false,
                moduleDrawer: false,
                umoduleDrawer: false,
                uoneLevelDrawer:false,
                pmdDrawer: false,
                selectedPerData: {},
                searchForm: {
                    permissionName:''
                },
                tableData: []
            }
        },
        created() {
            this.loadTableData(1);
        },
        methods:{
            closeWindow(msg){
                this.drawer = false;
                this.twoDrawer = false;
                this.moduleDrawer = false;
                this.umoduleDrawer = false;
                this.uoneLevelDrawer= false;
                this.pmdDrawer = false;
                if(msg){
                    this.loadTableData(1);
                    appjs.showSuccessMsg(msg,2000,50);
                }
            },
            loadTableData(){
                let load = appjs.loading();
                let _self = this;
                let params = this.searchForm;
                appjs.httpRequest('permission/queryAllPermission',params).then(
                    (data)=>{
                        if(data.retCode&&data.retCode!="ok"){
                            appjs.showErrorMsg(data.retMsg)
                        }else{
                            _self.tableData = data;
                            this.$refs.myElTable.bodyWrapper.scrollTop =0;
                        }
                        appjs.unloading(load);
                    }
                ).catch(
                    (errmsg)=>{
                        appjs.showErrorMsg(errmsg)
                        appjs.unloading(load);
                    });
            },
            updatePermission(rowdata){
                this.selectedPerData = rowdata;
                let _self  = this;
                setTimeout(function () {
                    if((_self.selectedPerData.parentpermissionpid=="superparent"||_self.selectedPerData.permissionurl=="/")&&_self.selectedPerData.ischildren=="n"){
                        _self.uoneLevelDrawer= true;
                        if(_self.$refs['updateOneLevelWindow']) {
                            _self.$refs['updateOneLevelWindow'].resertForm();
                        }
                    }else{
                        _self.umoduleDrawer = true;
                        if(_self.$refs['updateModuleWindow']) {
                            _self.$refs['updateModuleWindow'].resertForm();
                        }
                    }
                },100);
            },
            deletePermission(rowdata){
                let _self = this;
                this.$confirm('确定删除?', '提示', {
                    confirmButtonText: '确 定',
                    cancelButtonText: '取 消',
                    type: 'warning'
                }).then(() => {
                    let load = appjs.loading('数据删除中');
                    appjs.httpRequest('permission/deletePermission',{permissionPid:rowdata.id}).then(
                        (data)=>{
                            if(data.retCode&&data.retCode!="ok"){
                                appjs.unloading(load);
                                appjs.showErrorMsg(data.retMsg)
                            }else{
                                appjs.unloading(load);
                                appjs.showSuccessMsg(data.retMsg)
                                _self.loadTableData();
                            }
                        }
                    ).catch(
                        (errmsg)=>{
                            appjs.showErrorMsg(errmsg)
                            appjs.unloading(load);
                        });
                });
            },
            tableTrClick(row, column, event){
                this.$refs.myElTable.clearSelection();
                this.$refs.myElTable.toggleRowSelection(row);
            },
            urlFormatter(row, column){
                return appjs.HTMLDecode(row.permissionurl);
            },
            leavelFormatter(row, column){
                if(row.parentpermissionpid==null){
                    return "/";
                }else if(row.parentpermissionpid=='superparent'){
                    return  '一级菜单';
                }else if(row.permissionurl=="/"&&row.ischildren=="n"){
                    return "二级菜单";
                }else{
                    return "模块菜单";
                }
            },
            getStyle(row){
                if(row.parentpermissionpid=='superparent'){
                    return "bold";
                    //return "#35aaf8";
                }else if(row.permissionname=="功能菜单"){
                    return "bold";
                    //return "#cd4d07";
                }else if(row.permissionurl=="/"&&row.ischildren=="n"){
                    return "bold";
                    //return "#24c935";
                }
            },
            showAddOneLevelDialog(){
                this.drawer = true;
                if(this.$refs['addOneLevelWindow']) {
                    this.$refs['addOneLevelWindow'].resertForm();
                }
            },
            showAddTwoLevelDialog(){
                if(this.$refs.myElTable.store.states.selection.length!=1){
                    appjs.showWarningMsg('请选择一个一级菜单添加')
                    return;
                }
                if(this.$refs.myElTable.store.states.selection[0].parentpermissionpid!="superparent"){
                    appjs.showWarningMsg('请选择一个一级菜单添加')
                    return;
                }
                this.selectedPerData = this.$refs.myElTable.store.states.selection[0];
                let _self  = this;
                setTimeout(function () {
                    _self.twoDrawer = true;
                    if(_self.$refs['addTwoLevelWindow']) {
                        _self.$refs['addTwoLevelWindow'].resertForm();
                    }
                },100);
            },
            showAddModuleDialog(){
                if(this.$refs.myElTable.store.states.selection.length!=1){
                    appjs.showWarningMsg('请选择一个上级菜单添加')
                    return;
                }
                if(this.$refs.myElTable.store.states.selection[0].ischildren=="y"||this.$refs.myElTable.store.states.selection[0].parentpermissionpid=="superparent"||this.$refs.myElTable.store.states.selection[0].parentpermissionpid==undefined){
                    appjs.showWarningMsg('请选择一个二级菜单添加')
                    return;
                }
                this.selectedPerData = this.$refs.myElTable.store.states.selection[0];
                let _self  = this;
                _self.moduleDrawer = true;
                this.$nextTick(()=>{
                    if(_self.$refs['addModuleWindow']) {
                        _self.$refs['addModuleWindow'].resertForm();
                    }
                })
            },
            showAddMethodDialog(rowdata){
                this.selectedPerData = rowdata;
                let _self  = this;
                setTimeout(function () {
                    _self.pmdDrawer = true;
                    if(_self.$refs['permissionMdWindow']) {
                        _self.$refs['permissionMdWindow'].loadTableData();
                    }
                },100);
            }
        }
    }
</script>
